import { c as _c } from "react/compiler-runtime";
import { Button } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import NavigationHeader from '@/idv2/features/collect-document/components/navigation-header';
import IdDocAnimation from '../../../components/id-doc-animation';
import Loading from '../../../components/loading';
import RetryLimitExceeded from '../../../components/retry-limit-exceeded';
import Success from '../../../components/success';
type DesktopProcessingViewProps = {
  mode: 'loading' | 'success';
  step: 'upload' | 'analyze';
  showSlowConnectionMessage: boolean;
  retryLimitExceeded: boolean;
  isMissingRequirements: boolean;
  documentName: string;
  onRetryLimitExceeded: () => void;
  onSuccess: () => void;
};
const DesktopProcessingView = t0 => {
  const $ = _c(27);
  const {
    mode,
    step,
    showSlowConnectionMessage,
    retryLimitExceeded,
    isMissingRequirements,
    documentName,
    onRetryLimitExceeded,
    onSuccess
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.non-id-doc.pages.desktop-processing"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  if (isMissingRequirements) {
    let t2;
    if ($[1] !== t) {
      t2 = t(_temp);
      $[1] = t;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== t2) {
      t3 = <p className="text-label-1 text-error text-center fp-text">{t2}</p>;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  if (retryLimitExceeded) {
    let t2;
    if ($[5] !== onRetryLimitExceeded) {
      t2 = <RetryLimitExceeded onRetryLimitExceeded={onRetryLimitExceeded} />;
      $[5] = onRetryLimitExceeded;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    return t2;
  }
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <NavigationHeader leftButton={{
      variant: "close",
      confirmClose: true
    }} />;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== documentName) {
    t3 = <h2 className="text-heading-3 text-primary text-center">{documentName}</h2>;
    $[8] = documentName;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== showSlowConnectionMessage || $[11] !== step) {
    t4 = <Loading step={step} showSlowConnectionMessage={showSlowConnectionMessage} />;
    $[10] = showSlowConnectionMessage;
    $[11] = step;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Success />;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== mode || $[15] !== t4) {
    t6 = <div className="flex flex-col justify-center items-center bg-secondary border border-dashed border-primary rounded min-h-[280px]"><IdDocAnimation loadingComponent={t4} successComponent={t5} mode={mode} hasNextSide={false} /></div>;
    $[14] = mode;
    $[15] = t4;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const t7 = mode === "loading";
  let t8;
  if ($[17] !== t) {
    t8 = t(_temp2);
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== onSuccess || $[20] !== t7 || $[21] !== t8) {
    t9 = <Button fullWidth={true} disabled={t7} onClick={onSuccess} size="large">{t8}</Button>;
    $[19] = onSuccess;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t3 || $[24] !== t6 || $[25] !== t9) {
    t10 = <div className="flex flex-col gap-6 max-md:px-2">{t2}{t3}{t6}{t9}</div>;
    $[23] = t3;
    $[24] = t6;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
};
export default DesktopProcessingView;
function _temp($) {
  return $["missing-requirement-error"];
}
function _temp2($_0) {
  return $_0.continue;
}